import { useMemo, useRef } from "react";
import { Context, ValueProducers } from "common/components/types";
import { useForce } from "./use-force";
import { definedMap } from "@glideapps/ts-necessities";
import { shallowEqualArrays } from "common/Support";

export function useValueProducers(getValueProducers: (ctx: Context) => ValueProducers, ctx: Context) {
    return useMemo(() => getValueProducers(ctx), [ctx, getValueProducers]);
}

export function useForceValueProducers(
    getValueProducers: (ctx: Context) => ValueProducers,
    force: ReturnType<typeof useForce>[0],
    ctx: Context
) {
    const vps = useValueProducers(getValueProducers, ctx);
    const lastVPs = useRef(vps);
    const changed = !shallowEqualArrays(vps, lastVPs.current);

    return [vps.map(vp => definedMap(vp, force)), vps, changed] as const;
}
